export default __webpack_public_path__ + "static/media/langstone_550_340.d5f801f6.jpg";